import React from 'react'
import {isEmpty,isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
export default function LogoComponent(props) {
  return (
    <div className='d-flex align-items-center justify-content-center h-100 w-100'>
      {
        isEmpty(props.linkSrc) ?
        <h1 className='m-0' style={{fontSize: 50, fontWeight: 500,
          color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`
        }}><IntlMessages id="Label.Iframe"/></h1> : 
        <iframe 
          style={props.editing ? {pointerEvents: 'none'} : {}}
          src={props.linkSrc}
          frameBorder="0"
          height={"100%"}
          width="100%">
  
        </iframe>
      }
    </div>
  )
}
